// Module
var code = "<div class=\"popup-container [[{ '-backdrop': !!popup }]]\"> <div class=\"popup [[{ '-show': !!popup }]]\" view=\"show\" data-if=\"[[ !!popup ]]\"> <div role=\"dialog\" aria-modal=\"true\" js-popup view=\"[[ popup || 'empty' ]]\" data=\"[[ popup ]]\"></div>  </div> </div>";
// Exports
export default code;